import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigationType } from "react-router-dom";
import CustomBreadcrumb from "../../../components/customBreadcrumb/CustomBreadcrumb";
import CustomRadio from "../../../components/customRadio/CustomRadio";
import MainLoader from "../../../components/loading/MainLoader";
import ProductAndCircuitIdSelector from "../../../components/productAndCircuitIdSelector/ProductAndCircuitIdSelector";
import { ISelectOption } from "../../../components/selectOption/SelectOption";
import Title from "../../../components/title/Title";
import { EPackageType } from "../../../interfaces/packageType";
import { getCircuitsByUserID } from "../../../store/actions/dashborad.action";
import {
  clearUsageSummaryPageState,
  setBroadbandId,
  setSelectedPackageType,
  setSelectedUsagePageIndex,
} from "../../../store/actions/usageSummaryPage.action";
import { IRootState } from "../../../store/configureStore";
import AddOnUsage from "./addOnUsage/AddOnUsage";
import DailyUsage from "./dailyUsage/DailyUsage";
import MonthlyUsage from "./monthlyUsage/MonthlyUsage";

const UsageSummery = () => {
  const dispatch: any = useDispatch();
  const navigationType = useNavigationType();

  const { selectedRadioIndex, selectedPackageType, broadbandId } = useSelector(
    ({ usageSummaryPage }: IRootState) => ({
      selectedRadioIndex: usageSummaryPage.selectedUsageIndex,
      selectedPackageType: usageSummaryPage.selectedPackageType,
      broadbandId: usageSummaryPage.broadbandId,
    })
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [selectedCircuitId, setSelectedCircuitId] = useState<
    ISelectOption | []
  >([]);

  const { customerId, userId } = useSelector(({ privileges }: IRootState) => ({
    loading: privileges.loading,
    customerId: privileges.dataBundleUser?.customer.id,
    userId: privileges.dataBundleUser?.id,
  }));

  useEffect(() => {
    if (customerId) {
      dispatch(getCircuitsByUserID(userId));
    }
  }, [dispatch, userId, customerId]);

  useEffect(() => {
    if (navigationType === "PUSH") {
      dispatch(clearUsageSummaryPageState());
    }
  }, [navigationType, dispatch]);

  const handleChangeCircuitId = (value: ISelectOption | []) => {
    setSelectedCircuitId(value);
  };

  const radioIndexChangeHandler = (index: number) => {
    dispatch(setSelectedUsagePageIndex(index));
  };

  const getEnteredCircuitOrBroadbandId = (): string => {
    return selectedPackageType === EPackageType.BROADBAND
      ? broadbandId
      : (selectedCircuitId as ISelectOption).value;
  };

  return (
    <div className="page-container">
      <MainLoader show={loading} />
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          { path: "/serviceLineUp", title: "Service Line-up" },
          { path: "/serviceLineUp/usageSummery", title: "Usage Summary" },
        ]}
      />

      <Title>View Data Usage Summary</Title>

      <Row className="justify-content-center mt-3 pb-1">
        <Col className="col-md-10">
          <CustomRadio
            selectedIndex={selectedRadioIndex}
            onChange={radioIndexChangeHandler}
            items={[
              {
                label: "Monthly Usage",
                index: 0,
              },
              {
                label: "Daily Usage",
                index: 1,
              },
              {
                label: "Add on Usage",
                index: 2,
              },
            ]}
          />

          <ProductAndCircuitIdSelector
            selectedCircuitId={selectedCircuitId}
            selectedPackageType={selectedPackageType}
            setSelectedPackageType={(type) =>
              dispatch(setSelectedPackageType(type))
            }
            handleChangeCircuitId={handleChangeCircuitId}
            className="mt-1"
            onSearchInBroadbandId={(id) => dispatch(setBroadbandId(id))}
            isWithBroadband={selectedRadioIndex !== 2}
            // defaultPackageType={selectedPackageType}
            defaultBroadbandId={broadbandId}
          />

          {selectedRadioIndex === 0 && (
            <MonthlyUsage
              selectedCircuitId={getEnteredCircuitOrBroadbandId()}
              selectedPackageType={selectedPackageType as EPackageType}
              loading={loading}
              setLoading={setLoading}
            />
          )}
          {selectedRadioIndex === 1 && (
            <DailyUsage
              selectedCircuitId={getEnteredCircuitOrBroadbandId()}
              selectedPackageType={selectedPackageType as EPackageType}
              setLoading={setLoading}
            />
          )}
          {selectedRadioIndex === 2 && (
            <AddOnUsage
              selectedCircuitId={getEnteredCircuitOrBroadbandId()}
              selectedPackageType={selectedPackageType as EPackageType}
              loading={loading}
              setLoading={setLoading}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UsageSummery;
